// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GT35v","icon":"styles_icon__oO7kv"};